import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { grey } from '../neutral/colors.js';
export { grey } from '../neutral/colors.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var primary = {
  primary: '#BA0C2F',
  primaryDark: '#A10A28',
  primaryLight: '#E5B6BF'
};
var secondary = {
  secondaryLight: '#F5F6F7'
};
var accessory = {
  accessoryYellow: '#FFB774',
  accessoryYellowDark: '#E5A467',
  accessoryYellowLight: '#FFF0E1',
  accessoryBlue: '#4074BB',
  accessoryBlueDark: '#3763A1',
  accessoryBlueLight: '#E5F0FF',
  accessoryLavender: '#B59BFF',
  accessoryLavenderDark: '#A48CE5',
  accessoryLavenderLight: '#EEE8FF'
};
var success = {
  success: '#46DC78',
  successDark: '#3EC26A',
  successLight: '#E1FAEA'
};
var error = {
  error: '#FF1E4C',
  errorDark: '#E51C44',
  errorLight: '#FFEBEF'
};
var neutral = {
  black: '#000000',
  charcoal: '#282828',
  white: '#FFFFFF',
  warmLightBeige1: '#F5F0EB',
  warmLightBeige2: '#F0E7DE',
  warmLightGrey1: '#E5E2DF',
  warmLightGrey2: '#C6C3C0',
  warmMediumGrey: '#807E7C',
  lightGray: '#BFBFBF'
};
var colors = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, grey), primary), secondary), neutral), success), error), accessory);

export { accessory, colors, error, neutral, primary, secondary, success };
//# sourceMappingURL=colors.js.map
